import React from "react";
import { OrderMissionEntity } from "@src/features/order/entities";
import HistoryOrderRoute from "../history-order-route";

interface CompletedMapProps {
  order: OrderMissionEntity;
}

const CompletedMap: React.FC<CompletedMapProps> = ({ order }) => {
  if (!order) return null;
  return <HistoryOrderRoute order={order} droneVariant="idleGray" />;
};

export default CompletedMap;
